import { render } from "./index.vue?vue&type=template&id=c1648842&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c1648842&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=c1648842&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1648842"]])

export default __exports__